// پوسته‌ی مشترک صفحات فهرست
// چیدمان قفل‌شده را یک‌جا نگه می‌دارد: هدر و نوار ابزار بالا ثابت،
// فقط بدنه‌ی جدول اسکرول می‌خورد، و صفحه‌بندی همیشه ته صفحه ثابت است.
// هر صفحه فقط محتوای نوار ابزار (toolbar)، جدول (children) و دکمه‌ی صفحه بعد (footer) را می‌دهد.
import React from 'react';
import { TabBar } from '../pages/TabManager';
import { MoreButton } from './paging';

/**
 * پوستهٔ مشترک صفحات فهرست.
 *
 * صفحه‌بندی: کافی است `pager` (خروجی usePager) و `onMore` را بدهید؛ نوار
 * «۲۰۰ ردیف بعدی» خودکار در پایین صفحه و **بیرون از ناحیهٔ اسکرول** ساخته
 * می‌شود، پس همیشه بدون اسکرول دیده می‌شود. هیچ صفحه‌ای لازم نیست خودش
 * MoreButton را جایی بگذارد.
 *
 *   <ListPage ... pager={pg} onMore={p => load(p)} unit="قرارداد">
 *
 * `footer` برای نوار سفارشی است و بر pager اولویت دارد.
 */
export default function ListPage({
  user, onBack, title, subtitle = 'سامانه ارجان',
  toolbar = null, error = '', footer = null,
  pager = null, onMore = null, unit = 'ردیف', loading = false,
  children,
}) {
  // نوار پایین: یا سفارشی، یا خودکار از pager
  const bar = footer
    || (pager && onMore
        ? <MoreButton pager={pager} loading={loading} onMore={onMore} unit={unit} />
        : null);

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}>
            <img src={require('../assets/images/arjan.png')} alt="ارجان" style={{ width: '34px', height: '34px', borderRadius: '7px' }} />
          </div>
          <div><div style={s.hTitle}>{title}</div><div style={s.hSub}>{subtitle}</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>

      <TabBar />

      <main style={s.main}>
        {toolbar && <div style={s.toolbar}>{toolbar}</div>}
        {error && <div style={s.errBox}>⚠️ {error}</div>}
        <div style={s.tableWrap}>{children}</div>
        {bar && <div style={s.pagerBar}>{bar}</div>}
      </main>
    </div>
  );
}

// استایل‌های مشترکِ چیدمان — صفحات از ui برای دکمه/جدول/مودال استفاده می‌کنند
const s = {
  page:      { height: '100vh', overflow: 'hidden', background: '#f0f2f7', fontFamily: "'Vazirmatn',Tahoma,sans-serif", direction: 'rtl', display: 'flex', flexDirection: 'column' },
  header:    { background: 'linear-gradient(135deg,#0a1628,#1a2f50)', padding: '12px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 16px rgba(0,0,0,0.3)', flexShrink: 0 },
  hLeft:     { display: 'flex', alignItems: 'center', gap: '12px' },
  backBtn:   { padding: '6px 14px', background: 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '7px', cursor: 'pointer', fontFamily: 'inherit', fontSize: '13px' },
  hLogo:     { width: '40px', height: '40px', background: 'rgba(200,168,75,0.12)', border: '1px solid rgba(200,168,75,0.3)', borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  hTitle:    { fontSize: '14px', fontWeight: '700', color: '#fff' },
  hSub:      { fontSize: '11px', color: 'rgba(255,255,255,0.55)' },
  userName:  { fontSize: '13px', color: 'rgba(255,255,255,0.85)' },
  main:      { padding: '12px 24px', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 },
  toolbar:   { display: 'flex', alignItems: 'flex-end', gap: '12px', background: '#fff', padding: '14px 18px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', marginBottom: '12px', flexWrap: 'wrap', flexShrink: 0 },
  errBox:    { background: '#fff3f3', border: '1px solid #ffcdd2', borderRadius: '8px', padding: '10px 14px', color: '#c62828', marginBottom: '10px', fontSize: '13px', flexShrink: 0 },
  tableWrap: { flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'auto', borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', background: '#fff' },
  pagerBar:  { textAlign: 'center', padding: '10px 0 2px', flexShrink: 0 },
};

/* توکن‌های استایل مشترک برای استفاده در همه‌ی صفحات (دکمه‌ها، جدول، مودال) */
export const ui = {
  toolBtns:  { display: 'flex', gap: '8px', alignSelf: 'flex-end' },
  flabel:    { fontSize: '10px', fontWeight: '600', color: '#555' },
  mlabel:    { fontSize: '12px', fontWeight: '600', color: '#555' },
  yearInput: { width: '78px', padding: '6px 8px', border: '2px solid #C8A84B', borderRadius: '7px', fontSize: '14px', fontWeight: '700', textAlign: 'center', fontFamily: 'monospace', outline: 'none', color: '#1a2f50' },
  input:     { padding: '8px 10px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', fontFamily: "'Vazirmatn',Tahoma,sans-serif", outline: 'none', width: '100%', boxSizing: 'border-box', background: '#fff' },
  btnNew:    { padding: '9px 18px', background: 'linear-gradient(135deg,#1b5e20,#2e7d32)', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontFamily: 'inherit', fontSize: '13px', fontWeight: '700' },
  btnEdit:   { padding: '9px 18px', background: 'linear-gradient(135deg,#1a237e,#283593)', color: '#fff', border: 'none', borderRadius: '8px', fontFamily: 'inherit', fontSize: '13px', fontWeight: '700' },
  btnDel:    { padding: '9px 18px', background: 'linear-gradient(135deg,#b71c1c,#c62828)', color: '#fff', border: 'none', borderRadius: '8px', fontFamily: 'inherit', fontSize: '13px', fontWeight: '700' },
  btnItems:  { padding: '9px 18px', background: 'linear-gradient(135deg,#4a148c,#6a1b9a)', color: '#fff', border: 'none', borderRadius: '8px', fontFamily: 'inherit', fontSize: '13px', fontWeight: '700' },
  searchInput: { padding: '8px 12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', fontFamily: 'inherit', outline: 'none', alignSelf: 'flex-end' },
  countBadge: { padding: '5px 12px', background: '#1a2f50', color: '#C8A84B', borderRadius: '20px', fontSize: '12px', fontWeight: '700', alignSelf: 'flex-end' },
  errBox:    { background: '#fff3f3', border: '1px solid #ffcdd2', borderRadius: '8px', padding: '10px 14px', color: '#c62828', marginBottom: '10px', fontSize: '13px' },
  /* ── چیدمان دوتکه (گرید اصلی بالا + گرید فرزند پایین) ──
     گرید بالا اسکرول خودش را دارد و پنل پایین همیشه در دید است.
     بدون این، با ۲۰۰ ردیف، گرید فرزند و دکمهٔ صفحهٔ بعد
     زیر جدول گم می‌شوند. هر صفحهٔ دو-گریدی باید از همین‌ها استفاده کند. */
  splitWrap:  { display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 },
  topPane:    { flex: '1 1 45%', minHeight: '170px', overflow: 'auto' },
  bottomPane: { flex: '1 1 55%', minHeight: '200px', overflow: 'auto',
                borderTop: '2px solid #e0e0e0', background: '#fafbfd' },

  table:     { width: '100%', borderCollapse: 'collapse' },
  th:        { padding: '9px 8px', background: '#1a2f50', color: '#fff', fontWeight: '700', textAlign: 'center', whiteSpace: 'nowrap', borderLeft: '1px solid rgba(255,255,255,0.1)', fontFamily: 'inherit', fontSize: '11px', position: 'sticky', top: 0, zIndex: 2 },
  td:        { padding: '6px 7px', borderBottom: '1px solid #f0f0f0', textAlign: 'center', fontSize: '12px', whiteSpace: 'nowrap' },
  tdNum:     { padding: '6px 7px', borderBottom: '1px solid #f0f0f0', textAlign: 'center', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap' },
  empty:     { textAlign: 'center', padding: '40px', color: '#999' },
  overlay:   { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' },
  modal:     { background: '#fff', borderRadius: '16px', width: '100%', maxHeight: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' },
  mHeader:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: 'linear-gradient(135deg,#0a1628,#1a2f50)', borderRadius: '16px 16px 0 0' },
  mTitle:    { fontSize: '15px', fontWeight: '700', color: '#fff' },
  closeBtn:  { background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', width: '30px', height: '30px', borderRadius: '50%', cursor: 'pointer', fontSize: '13px' },
  mBody:     { overflowY: 'auto', flex: 1, padding: '20px' },
  mFooter:   { display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '12px 20px', borderTop: '1px solid #f0f2f7', background: '#f8f9fa', borderRadius: '0 0 16px 16px' },
  row:       { display: 'flex', gap: '14px', marginBottom: '12px', flexWrap: 'wrap' },
  divider:   { height: '1px', background: '#f0f2f7', margin: '10px 0' },
  btnCancel: { padding: '8px 20px', background: '#e0e0e0', color: '#333', border: 'none', borderRadius: '8px', cursor: 'pointer', fontFamily: 'inherit', fontSize: '13px' },
  btnSave:   { padding: '8px 24px', background: 'linear-gradient(135deg,#1b5e20,#2e7d32)', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontFamily: 'inherit', fontSize: '13px', fontWeight: '700' },
  toast:     { position: 'fixed', bottom: '24px', right: '24px', background: '#1b5e20', color: '#fff', padding: '12px 24px', borderRadius: '10px', fontSize: '14px', fontWeight: '600', zIndex: 2000, boxShadow: '0 4px 16px rgba(0,0,0,0.25)' },
};
